const angular = require('angular');
var app = angular.module('learn-resources');

/**
* Defines the Custom Copy Directive which allows for custom copy behavior as needed
* @argument {Application} Application injected to gain access to the global Application functions and properties
*/

app.factory('customCopy', ['Application', 'Authorization', function(Application) {
  var self = this;
  self.customCopy = Application.customCopy;
  if (self.customCopy) {
    return self.customCopy;
  }
  return {};
}]);